export default __webpack_public_path__ + "static/media/mobile_beehive_harvest_status_uk.b4d6226c.png";